import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IStudentAssignedSubscriptionPlanResultVm } from '../student-assigned-subscription-plan-result-vm.model';
import { IStudentAssignedSubscriptionPlanResultIm } from '../student-assigned-subscription-plan-result-im.model';
@Injectable({ providedIn: 'root' })
export class StudentAssignedSubscriptionPlanService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/StudentAssignedSubscriptionPlan`;
  }
  post(subscriptionPlanResultIm: IStudentAssignedSubscriptionPlanResultIm): Observable<IStudentAssignedSubscriptionPlanResultVm> {
    const headers = this.createHeaders();
    return this.http.post<IStudentAssignedSubscriptionPlanResultVm>(this.baseUrl, subscriptionPlanResultIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
